import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDAlert, FDHeadlineText } from '@facet-wealth/design';
import { buildBaseOverrides } from 'Components/UI/guidedHouseholdReview/baseOverrides';
import { pick } from 'Helpers/Affordances';
import GuidedHouseholdReviewLayout from './GuidedHouseholdReviewLayout';
import RoadmapDeliverableLayout from './RoadmapDeliverableLayout';

const addOverrides = (baseOverrides) => baseOverrides
  .nameOverride(['actionsTitle', 'nextStepsTitle'], {
    _component: () => FDHeadlineText,
    _customProps: { size: 'sm' },
  }, overrideReadOnly)
  .nameOverride('actionsDisclaimer', {
    _component: () => FDAlert,
    _customProps: { status: 'info' },
  }, overrideReadOnly)
  .done();

const roadmapDeliverableMetaOverrideSet = addOverrides(buildFacetDesignOverride());
const guidedHouseholdReviewMetaOverrideSet = addOverrides(buildBaseOverrides());

const RoadmapActionsThisMonthStepTemplate = ({ resource }) => {
  const layout = pick(resource, {
    [fr.relationships.guidedHouseholdReviewLayout.name]: GuidedHouseholdReviewLayout,
  }, RoadmapDeliverableLayout);
  const metaOverrideSet = pick(resource, {
    [fr.relationships.guidedHouseholdReviewLayout.name]: guidedHouseholdReviewMetaOverrideSet,
  }, roadmapDeliverableMetaOverrideSet);
  return (
    <MetaResourceRenderer
      layout={layout}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

RoadmapActionsThisMonthStepTemplate.defaultProps = {
};

RoadmapActionsThisMonthStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default RoadmapActionsThisMonthStepTemplate;
